module.exports = __webpack_public_path__ + "img/info-svg.aa7e71db.svg";